import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useForm, Controller } from 'react-hook-form';
import FieldErrorText from 'components/base/field-error-text';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';
import { FormContainer } from './styles';

interface IPushNotificationsFormProps {
  sendPushNotification: (
    title: string,
    description: string,
  ) => Promise<boolean | undefined>;
  isLoading: boolean;
  isReadOnly?: boolean;
}

const PushNotificationsForm: React.FC<IPushNotificationsFormProps> = ({
  sendPushNotification,
  isLoading,
  isReadOnly = false,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: 'onTouched',
    defaultValues: {
      title: '',
      description: '',
    },
  });

  const onSubmit = async (data: { title: string; description: string }) => {
    const success = await sendPushNotification(data.title, data.description);
    if (success) {
      reset();
    }
  };

  return (
    <Card>
      <FormContainer>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="field">
            <label htmlFor="title">Заголовок</label>
            <Controller
              name="title"
              control={control}
              rules={{ required: 'Заголовок обязателен' }}
              render={({ field, fieldState }) => (
                <InputText
                  id="title"
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={field.onChange}
                  value={field.value}
                  ref={field.ref}
                  maxLength={50}
                  className={fieldState.invalid ? 'p-invalid' : ''}
                  disabled={isReadOnly}
                />
              )}
            />
            {errors.title?.message && (
              <FieldErrorText errorText={errors.title.message} />
            )}
          </div>
          <div className="field">
            <label htmlFor="description">Описание</label>
            <Controller
              name="description"
              control={control}
              rules={{ required: 'Описание обязательно' }}
              render={({ field, fieldState }) => (
                <InputTextarea
                  id="description"
                  name={field.name}
                  onBlur={field.onBlur}
                  onChange={field.onChange}
                  value={field.value}
                  ref={field.ref}
                  rows={10}
                  maxLength={400}
                  className={fieldState.invalid ? 'p-invalid' : ''}
                  disabled={isReadOnly}
                />
              )}
            />
            {errors.description?.message && (
              <FieldErrorText errorText={errors.description.message} />
            )}
          </div>
          <Button
            label="Отправить"
            className="p-button-success"
            disabled={!isValid || isLoading || isReadOnly}
            loading={isLoading}
            type="submit"
          />
        </form>
      </FormContainer>
    </Card>
  );
};

export default PushNotificationsForm;
